<template>
  <div class="flex justify-between space-x-3">
    <div class="w-1/4 bg-dash-green boxes pt-5 pb-3 px-3 rounded-md">
      <p class="text-white font-light text-sm">
        SUCCESSFUL TRANSACTION AS AT TODAY
      </p>
      <div class="flex justify-between">
        <div class="mt-3">
          <p class="text-white font-bold text-3xl">
            {{ formatMoney(totalAmount.success) }}
          </p>
          <p class="text-white font-bold mt-3">
            COUNT - {{ totalCount.success }}
          </p>
        </div>
        <div class="mt-4">
          <i class="fa fa-globe text-6xl text-green-light"></i>
        </div>
      </div>
    </div>

    <div class="w-1/4 bg-dash-red boxes pt-5 pb-3 px-3 rounded-md">
      <p class="text-white font-light text-sm">
        FAILED TRANSACTION AS AT TODAY
      </p>
      <div class="flex justify-between">
        <div class="mt-3">
          <p class="text-white font-bold text-3xl">
            {{ formatMoney(totalAmount.failed) }}
          </p>
          <p class="text-white font-bold mt-3">
            COUNT - {{ totalCount.failed }}
          </p>
        </div>
        <div class="mt-4">
          <i class="fa fa-exclamation-triangle text-6xl text-red-light"></i>
        </div>
      </div>
    </div>

    <div class="w-1/4 bg-blue-dark boxes rounded pt-1">
      <div id="chart">
        <apexchart
          type="pie"
          height="152"
          :options="pieOptions1"
          :series="pieSeries1"
        ></apexchart>
      </div>
    </div>

    <div class="w-1/4 bg-blue-dark boxes rounded pt-1">
      <div id="chart" style="width: 340px">
        <apexchart
          type="pie"
          height="152"
          :options="pieOptions2"
          :series="pieSeries2"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxPieCharts",
  props: {
    bg_line: String,
    totalAmount: Object,
    totalCount: Object,
    groupSuccess: Object,
    groupFailed: Object,
  },

  data() {
    return {
      pieOptions1: {
        chart: {
          type: "pie",
          foreColor: "#e6e6e6",
          offsetX: 0,
        },
        labels: this.groupSuccess.labels,
        colors: [
          "#2E93fA",
          "#800000",
          "#546E7A",
          "#E91E63",
          "#66DA26",
          "#FF9800",
        ],
        stroke: {
          width: 0,
        },
        legend: {
          position: "left",
          fontSize: "8px",
          markers: {
            width: 5,
            height: 5,
          },
          formatter: function(seriesName, opts) {
            const sname = seriesName.split(" ");
            return sname[0] + " " + sname[1];
          },
        },
        title: {
          text: "INSTITUTIONS SUCCESSFUL TRANSACTION COUNT",
          floating: false,
          style: {
            fontSize: "10px",
            fontWeight: "thin",
            cssClass: "break-words",
          },
        },
      },
      // pieSeries1: [15, 15, 44, 55, 41, 17],
      pieSeries1: this.groupSuccess.counts,
      pieOptions2: {
        chart: {
          type: "pie",
          foreColor: "#e6e6e6",
        },
        labels: this.groupFailed.labels,
        colors: [
          "#2E93fA",
          "#66DA26",
          "#546E7A",
          "#E91E63",
          "#FF9800",
          "#800000",
        ],
        // theme: {
        //   monochrome: {
        //     enabled: true,
        //     color: "#800000",
        //     shadeIntensity: 0.7,
        //   },
        // },
        stroke: {
          width: 0,
        },
        legend: {
          position: "left",
          fontSize: "8px",
          markers: {
            width: 5,
            height: 5,
          },
          formatter: function(seriesName, opts) {
            const sname = seriesName.split(" ");
            return sname[0] + " " + sname[1];
          },
        },
        title: {
          text: "INSTITUTIONS FAILED TRANSACTION COUNT",
          floating: false,
          style: {
            fontSize: "10px",
            fontWeight: "thin",
          },
        },
      },
      pieSeries2: this.groupFailed.counts,
    };
  },
  methods: {
    formatMoney(amt) {
      return "₦" + Number(amt).toLocaleString();
    },
  },
};
</script>
<style scoped>
.boxes {
  /* height: 189px; */
  max-height: 163px !important;
}
</style>
